import Vue from 'vue';
import offerPage from './components/offer-page.vue';

/* eslint-disable no-new */
new Vue({
	el: '#rwjobpe-app',
	components: {
		offerPage
	}
});
